export default {
  nav: {
    main: 'Pagrindinis',
    ordersAndInvoices: 'Užsakymai ir sąskaitos',
    drafts: 'Juodraščiai',
    automation: 'Automatizavimas',
    workspace: 'Darbo erdvė',
    templates: 'Šablonai',
    delivery: 'Pristatymas',
    settings: 'Nustatymai',
    shippingLabels: 'Siuntų etiketės',
    subscriptions: 'Prenumeratos',
    support: 'Pagalba',
    developer: 'Kūrėjas',
    writeReview: 'Parašyti atsiliepimą',
    supportTicket: 'Pagalbos užklausa',
    welcomeTour: 'Pažintinė ekskursija',
    administratorConsole: 'Administratoriaus konsolė',
    logout: 'Atsijungti',
  },
  dashboard: {
    pageTitle: 'Užsakymai ir sąskaitos',
    pageDescription: 'Manage your orders and invoices',
    title: 'Užsakymai ir sąskaitos',
    selectedOrders: '{count} pasirinktų užsakymų',
    completed: '% atlikta',
    processing: 'Apdorojama, palaukite...',
    bulkDownload: 'Masinis atsisiuntimas',
    upgradeBulkDownload: 'Atnaujinkite planą masiniam atsisiuntimui',
    showFilters: 'Rodyti filtrus',
    hideFilters: 'Slėpti filtrus',
    creatingInvoices: 'Kuriamos sąskaitos, palaukite...',
    bulkCreateInvoices: 'Masinis sąskaitų kūrimas',
    cannotCreateAutopilot: 'Negalite rankiniu būdu kurti sąskaitų, kai sąskaitų režimas yra automatinis.',
    exportInvoices: 'Eksportuoti sąskaitas arba užsakymus',
    capturePayments: 'Fiksuoti mokėjimus rankiniu būdu',
    filterOrders: 'Filtruoti užsakymus',
    error: 'Oi, kažkas nutiko ne taip...',
    close: 'Uždaryti',
    chooseDate: 'Pasirinkite datą',
    chooseIssueDate: 'Pasirinkite išrašymo datą pasirinktoms sąskaitoms',
    cancel: 'Atšaukti',
    createInvoices: 'Sukurti sąskaitas',
    storno: 'Storno',
    bulkOrderCapture: 'Masinis užsakymų fiksavimas',
  },
  search: {
    createdBetween: 'Sukurta tarp',
    modifiedBetween: 'Pakeista tarp',
    orderNumber: 'Užsakymo Nr.',
    invoiceNumber: 'Sąskaitos Nr.',
    refundNumber: 'Grąžinimo Nr.',
    customer: 'Klientas',
    payment: 'Mokėjimas',
    any: 'Bet koks',
    authorized: 'Autorizuota',
    pending: 'Laukiama',
    paid: 'Apmokėta',
    partiallyPaid: 'Dalinai apmokėta',
    refunded: 'Grąžinta',
    voided: 'Anuliuota',
    partiallyRefunded: 'Dalinai grąžinta',
    unpaid: 'Neapmokėta',
    fulfillment: 'Įvykdymas',
    fulfilled: 'Pristatyta',
    partial: 'Dalinė',
    unfulfilled: 'Nepristatyta',
    loading: 'Kraunami užsakymai...',
    search: 'Ieškoti',
  },
  orderList: {
    noCustomer: 'Nėra kliento',
    downloadOrder: 'Atsisiųsti užsakymą',
    deleteWarning: 'Svarbu! Bus ištrintos visos sąskaitos ir grąžinimai sukurti po datos:',
    includingInvoice: 'įskaitant pasirinktą sąskaitą Nr.',
    pressOk: 'Spauskite OK norėdami tęsti arba Atšaukti norėdami nutraukti.',
    cannotCreateAutopilot: 'Negalite rankiniu būdu kurti sąskaitų, kai sąskaitų režimas yra automatinis.',
    createInvoice: 'Sukurti sąskaitą šiam užsakymui',
    create: 'Sukurti',
    addCreditNote: 'Pridėti kreditinę pažymą',
    createStorno: 'Sukurti storno sąskaitą',
    refund: 'Grąžinimas',
    downloadInvoice: 'Atsisiųsti šią sąskaitą',
    download: 'Atsisiųsti',
    default: 'Numatytasis',
    downloadStorno: 'Atsisiųsti šią storno/kreditinę pažymą',
    fulfillOrder: 'Įvykdyti užsakymą',
    orderNum: 'Užsakymo Nr.',
    locPrefix: 'Vietos prefiksas',
    invoiceNum: 'Sąskaitos Nr.',
    refundNum: 'Grąžinimo Nr.',
    customerCol: 'Klientas',
    orderCreatedDate: 'Užsakymo sukūrimo data',
    orderModifiedDate: 'Užsakymo pakeitimo data',
    delivered: 'Pristatyta',
    paymentStatus: 'Mokėjimo būsena',
    fulfillmentStatus: 'Pristatymo būsena',
    totalOutstanding: 'Bendra neapmokėta suma',
    originalPrice: 'Pradinė kaina',
    noOrders: 'Jūsų parduotuvėje nėra užsakymų su pasirinkta būsena.',
    cannotCreateNoOrders: 'Negalite sukurti sąskaitų, kai nėra užsakymų.',
    createOrdersFirst: 'Prašome sukurti bent vieną užsakymą ir bandyti dar kartą.',
    createOrders: 'Sukurti užsakymus',
    loadingOrders: 'Kraunama...',
    paidManual: 'Apmokėta - Rankiniu būdu',
    paid: 'Apmokėta',
    refunded: 'Grąžinta',
    pending: 'Laukiama',
    partiallyPaid: 'Dalinai apmokėta',
    partiallyRefunded: 'Dalinai grąžinta',
    fulfilled: 'Pristatyta',
    unfulfilled: 'Nepristatyta',
    deliveryPending: 'Laukiama',
    deliverNow: 'Pristatyti dabar',
    deliveryPartial: 'Dalinė',
    notDelivered: 'Nepristatyta',
    deliverAgain: 'Pristatyti dar kartą',
    deliveryDetails: 'Pristatymo informacija',
    deliveryFailed: 'Pristatymas nepavyko',
    sent: 'Išsiųsta',
    failed: 'Nepavyko',
    toLabel: 'Kam',
    folderLabel: 'Aplankas',
    open: 'Atidaryta',
    invoice: 'Sąskaita',
    creditNote: 'Kreditinė nota',
    stornoLabel: 'Storno',
    unknown: 'Nežinoma',
    googleDrive: 'Google Drive',
    clientsTablet: 'Klientų planšetė',
    shippyPro: 'ShippyPro',
    emailChannel: 'El. paštas',
    ftpChannel: 'FTP',
    revertToDate: 'Grąžinti į šią datą',
    add: 'Pridėti',
    close: 'Uždaryti',
  },
  downloadDialog: {
    downloadType: 'Atsisiųsti {type}...',
    selectTemplate: 'Pasirinkite šabloną iš galerijos užsakymų, sąskaitų, storno sąskaitų ar kreditinių pažymų eksportui.',
    getMoreTemplates: 'Gauti daugiau šablonų',
    createNewTemplate: 'Sukurti naują šabloną',
    allCreatedBetween: 'Visos sukurtos {type} tarp',
    selectedType: 'Pasirinkti {type}',
    and: 'ir',
    status: 'Būsena',
    any: 'Bet koks',
    open: 'Atidaryta',
    closed: 'Uždaryta',
    cancelled: 'Atšaukta',
    paymentStatus: 'Mokėjimo būsena',
    fulfillmentStatus: 'Pristatymo būsena',
    fulfilled: 'Pristatyta',
    partial: 'Dalinė',
    unfulfilled: 'Nepristatyta',
    authorized: 'Autorizuota',
    pending: 'Laukiama',
    paid: 'Apmokėta',
    partiallyPaid: 'Dalinai apmokėta',
    refunded: 'Grąžinta',
    voided: 'Anuliuota',
    partiallyRefunded: 'Dalinai grąžinta',
    unpaid: 'Neapmokėta',
    format: 'Formatas',
    forLocation: 'Vieta',
    advancedOptions: 'Išplėstinės parinktys',
    exportHSCodes: 'Eksportuoti inventoriaus HS kodus (lėčiau)',
    noteChrome: 'Pastaba: Optimaliam atsisiuntimui rekomenduojama Chrome ir išjungtas reklamos blokatorius.',
    downloadIndividually: 'Atsisiųsti atskirai',
    downloadGrouped: 'Atsisiųsti sugrupuotus',
  },
  templates: {
    pageTitle: 'Šablonai',
    pageDescription: 'Customize your invoice templates',
    title: 'Šablonai',
    installTranslated: 'Įdiegti išverstą šabloną',
    installTranslatedDesc: 'Pasirinkite kitą kalbą paspaudę šį mygtuką.',
    createNew: 'Sukurti naują šabloną jei reikia',
    createNewDesc: 'Spauskite šį mygtuką norėdami sukurti naują šabloną jei reikia.',
    customize: 'Pritaikyti šablonus',
    customizeDesc: 'Spauskite ant numatytojo šablono norėdami jį pritaikyti. Galite keisti logotipą, spalvas ir pažengusiems naudotojams – kodą.',
    defaultTemplate: 'Sąskaita, Storno ir Kreditinė pažyma (Numatytasis)',
    logo: 'Logotipas',
    colorPalette: 'Spalvų paletė',
    getColorPalettes: 'Gauti spalvų paletes',
    paperSize: 'Popieriaus dydis',
    format: 'Formatas',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientacija',
    landscape: 'Gulsčias',
    portrait: 'Stačias',
    margin: 'Paraštė (cm)',
    unsavedChanges: 'Neišsaugoti pakeitimai',
    discard: 'Atmesti',
    save: 'Išsaugoti',
  },
  labels: {
    pageTitle: 'Siuntų etiketės',
    pageDescription: 'Create and manage shipping labels',
    title: 'Siuntų etiketės',
    glsRequiresPro: 'GLS siuntų etiketės EEU reikalauja Profesionalaus plano.',
    upgradeDesc: 'Atnaujinkite iki Profesionalaus norėdami kurti ir valdyti siuntų etiketes.',
    upgradePlan: 'Atnaujinti planą',
    eeuGls: 'EEU GLS',
    enabled: 'Įjungta',
    country: 'Šalis',
    hungary: 'Vengrija',
    slovakia: 'Slovakija',
    czech: 'Čekija',
    romania: 'Rumunija',
    slovenia: 'Slovėnija',
    croatia: 'Kroatija',
    senderId: 'Siuntėjo ID',
    username: 'Naudotojo vardas',
    password: 'Slaptažodis',
    name: 'Pavadinimas',
    city: 'Miestas',
    address: 'Adresas',
    zipCode: 'Pašto kodas',
    contactPerson: 'Kontaktinis asmuo',
    phone: 'Telefonas',
    email: 'El. paštas',
    glsServices: 'GLS paslaugos',
    expressService: 'Greitoji paslauga',
    exchangeService: 'Keitimo paslauga',
    smsService: 'SMS paslauga',
    smsText: 'SMS tekstas',
    preAdviceService: 'Išankstinio pranešimo paslauga',
    unsavedChanges: 'Neišsaugoti pakeitimai',
    discard: 'Atmesti',
    save: 'Išsaugoti',
  },
  billing: {
    pageTitle: 'Atsiskaitymas',
    pageDescription: 'Manage your subscription and billing',
    title: 'Atsiskaitymas',
    subscriptionFor: 'Prenumeratos planas parduotuvei',
    currentlySubscribed: 'Šiuo metu prenumeruojate',
    plan: 'planą',
    cancelSubscription: 'Atšaukti prenumeratą',
    upgradePlan: 'Atnaujinti planą',
    professional: 'Profesionalus',
    proPriceMonthly: '$29.99 / mėn.',
    upgrade: 'Atnaujinti',
    includesAllStarter: 'Apima visas Pradinio plano funkcijas, plius:',
    proFeature1: 'Visuotinės atitikties rinkinys: vietos prefiksai ir pasirinktinė nuosekli numeracija',
    proFeature2: 'Išmanioji lokalizacija: automatiškai versti el. laiškai ir lokalizuoti PDF priedai',
    proFeature3: 'Pilnas B2B dokumentų ciklas: išankstinės sąskaitos, B2B pasiūlymai ir kreditinės pažymos',
    proFeature4: 'B2B apskaitos sinchronizacija: 3 skaitmenų tikslumas ir kelių valiutų rodymas',
    proFeature5: 'Automatinės atsarginės kopijos: automatinis sąskaitų kopijavimas į saugų FTP arba Google Drive',
    proFeature6: 'Shopify Flow: automatizuokite sąskaitų generavimą, pristatymą ir storno per Flow trigerius ir veiksmus',
    proFeature7: 'Išplėstinė AI logika: naudokite įrenginio AI sudėtingoms sąlyginėms išdėstymo sąlygoms',
    proFeature8: 'UBL XML ir ZUGFeRD / Factur-X eksportas (Europos e-sąskaitų atitiktis)',
    proFeature9: 'EPC QR kodai momentiniams mobiliems POS mokėjimams',
    proFeature10: 'GLS siuntų etiketės EEU',
    proFeature11: '7 metų atitikties mokestinė saugojimo trukmė',
    currentlyUsing: 'Šiuo metu naudojate mūsų',
    free: 'nemokamą',
    subscriptionPlan: 'prenumeratos planą.',
    monthlyUsage: 'Mėnesinis naudojimas',
    monthlyGenerated: '{count} / 50 sąskaitų šį mėnesį',
    monthlyLimitReached: 'Mėnesinis limitas pasiektas. Atnaujinkite iki Pradinio plano neribotoms sąskaitoms.',
    freePlan: 'Nemokamas planas',
    freeToInstall: 'Nemokamas įdiegimas',
    freeFeature1: 'Iki 50 sąskaitų/užsakymų per mėnesį',
    freeFeature2: 'Prieiga prie visų 31+ iš anksto paruoštų šablonų',
    freeFeature3: 'Bazinis AI asistentas',
    freeFeature4: 'Standartinis PDF atsisiuntimas ir spausdinimas',
    freeFeature5: 'Standartinis dokumentų rinkinys (sąskaitos, pakavimo lapeliai, kvitai)',
    freeFeature6: '3 mėnesių saugus sąskaitų saugojimas',
    starterPlan: 'Pradinis planas',
    starterPrice: '$9.99 / mėn.',
    starterPricePerInvoice: '+ 3¢ už sukurtą sąskaitą',
    subscribe: 'Prenumeruoti',
    starterFeature1: 'Neriboti sąskaitos ir užsakymai',
    starterFeature2: 'Automatinis PDF pristatymas el. paštu',
    starterFeature3: 'Pilna prieiga prie hibridinio redaktoriaus ir AI asistento',
    starterFeature4: 'Shopify POS ir brūkšninio kodo integracija',
    starterFeature5: 'Shopify Flow: trigeriai ir veiksmai sąskaitų automatizavimui',
    starterFeature6: 'UBL XML / PEPPOL ir ZUGFeRD / Factur-X eksportas (e-sąskaitų atitiktis)',
    starterFeature7: '1 metų saugus sąskaitų saugojimas',
    proTaxOverrides: 'Pasirinktiniai mokesčių perrašymai: PVM / GST pagal produktą ir SKU lygio tarifai',
    unsavedChanges: 'Neišsaugoti pakeitimai',
    discard: 'Atmesti',
    save: 'Išsaugoti',
  },
  autopilot: {
    pageTitle: 'Automatizavimas',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatizavimas',
    autoCreate: 'Automatiškai kurti sąskaitas',
    disabled: 'Išjungta (Rankinis)',
    whenCreated: 'Kai užsakymai sukuriami',
    whenFulfilled: 'Kai užsakymai įvykdomi',
    whenPaid: 'Kai užsakymai apmokomi',
    autoCreateDesc: 'Sąskaitos bus sukurtos tą dieną, kai užsakymai sukuriami, įvykdomi arba apmokomi.',
    autoStorno: 'Automatiškai stornuoti sąskaitas',
    whenCancelled: 'Kai užsakymai atšaukiami arba grąžinami',
    autoStornoDesc: 'Storno sąskaitos bus sukurtos tą dieną, kai užsakymai anuliuojami/atšaukiami arba grąžinimai sukuriami.',
    cannotAutoFree: 'Automatinis sąskaitų kūrimas negalimas su nemokamu planu.',
    upgradePlan: 'Atnaujinti planą',
    unsavedChanges: 'Neišsaugoti pakeitimai',
    discard: 'Atmesti',
    save: 'Išsaugoti',
  },
  delivery: {
    pageTitle: 'Pristatymas',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Pristatymas',
    settings: 'Nustatymai',
    useOrderNumbers: 'Naudoti užsakymų numerius failams',
    sendIfCountry: 'Siųsti jei atsiskaitymo adreso šalis yra',
    countryCodesHint: 'Išvardykite visus šalių kodus atskirtus kabliataškiu.',
    sendForTags: 'Siųsti klientams turintiems vieną iš nurodytų žymų',
    tagsHint: 'Išvardykite visas žymas atskirtas kabliataškiu.',
    emailDelivery: 'Pristatymas el. paštu',
    sendAsPdf: 'Siųsti sąskaitas kaip PDF priedus klientams',
    autoSend: 'Automatiškai siųsti kai sąskaita sukuriama',
    subject: 'Tema',
    body: 'Turinys',
    xmlAttachments: 'XML priedai',
    attachUbl: 'Pridėti UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Pridėti ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Siųsti bandomąjį el. laišką',
    sending: 'Siunčiama...',
    customSmtp: 'Pasirinktinis SMTP serveris',
    customSmtpDesc: 'Naudoti savo pašto serverį vietoj numatytojo',
    enableSmtp: 'Įjungti pasirinktinį SMTP',
    smtpHost: 'SMTP serveris',
    port: 'Prievadas',
    useSsl: 'Naudoti SSL/TLS',
    username: 'Naudotojo vardas',
    password: 'Slaptažodis',
    fromEmail: 'Siuntėjo el. paštas',
    fromName: 'Siuntėjo vardas',
    shopifyLiquid: 'Shopify Liquid šablonas',
    pasteInto: 'Įklijuokite tai į savo',
    orderConfirmation: 'užsakymo patvirtinimo šabloną',
    toAddLink: 'norėdami pridėti atsisiuntimo nuorodą.',
    downloadInvoice: 'Atsisiųsti sąskaitą',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Siųsti užklausas į ClientsTablet kai sąskaitos sukuriamos',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Siųsti PDF sąskaitas kaip muitinės dokumentus į ShippyPro ne ES šalims',
    ftpBackup: 'FTP / SFTP atsarginė kopija',
    ftpDesc: 'Automatiškai kopijuoti sąskaitas į jūsų serverį',
    enableFtp: 'Įjungti automatinę FTP atsarginę kopiją',
    host: 'Serveris',
    useSftp: 'Naudoti SFTP (saugus)',
    destinationFolder: 'Paskirties aplankas',
    xmlFiles: 'XML failai',
    includeUbl: 'Įtraukti UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Įtraukti ZUGFeRD / Factur-X XML',
    testConnection: 'Tikrinti ryšį',
    testing: 'Tikrinama...',
    pro: 'PRO',
    upgradeFtp: 'Atnaujinkite iki Profesionalaus norėdami automatiškai kopijuoti sąskaitas į FTP/SFTP serverį.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Automatiškai sinchronizuoti sąskaitas į jūsų Drive',
    connected: 'Prijungta',
    disconnect: 'Atjungti',
    notWorking: 'Neveikia? Eikite į',
    googlePermissions: 'Google leidimus',
    removeThenReconnect: 'pašalinkite Invoice Browse, tada prisijunkite iš naujo.',
    connectGoogleDrive: 'Prijungti Google Drive',
    upgradeGoogleDrive: 'Atnaujinkite iki Profesionalaus norėdami automatiškai sinchronizuoti sąskaitas į Google Drive.',
    unsavedChanges: 'Neišsaugoti pakeitimai',
    discard: 'Atmesti',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Išsaugoti',
  },
  bookkeeping: {
    pageTitle: 'Nustatymai',
    pageDescription: 'Configure your invoice settings',
    title: 'Nustatymai',
    owner: 'Savininkas',
    email: 'El. paštas',
    phone: 'Telefonas',
    keepDifferentNumbering: 'Laikyti skirtingą sąskaitų numeraciją kiekvienai užsakymo vietai',
    keepDifferentNumberingDisabled: 'Skirtingos sąskaitų numeracijos kiekvienai užsakymo vietai pasirinkimas nėra įjungtas su jūsų planu.',
    locationEmailDesc: 'Tai leidžia siųsti el. laiškus ir sąskaitas išverstas pagal užsakymo vietą: inventoriaus vietą, pristatymo arba atsiskaitymo adresą',
    upgradePlan: 'Atnaujinti planą',
    matchingCriteria: 'Atitikimo kriterijai',
    locationId: 'Vietos ID',
    shippingCountryCode: 'Pristatymo adreso šalies kodas',
    billingCountryCode: 'Atsiskaitymo adreso šalies kodas',
    matchLocationDesc: 'Atitikti vietą pagal užsakymo vietos ID, pristatymo arba atsiskaitymo adreso šalies kodą.',
    companyInfo: 'Įmonės informacija',
    name: 'Pavadinimas',
    website: 'Svetainė',
    registrationNumber: 'Registracijos numeris',
    taxId: 'Mokesčių mokėtojo kodas',
    addressSection: 'Adresas',
    streetName: 'Gatvės pavadinimas',
    streetNumber: 'Gatvės numeris',
    zip: 'Pašto kodas',
    city: 'Miestas',
    region: 'Regionas',
    country: 'Šalis',
    bankingInfo: 'Banko informacija',
    bankName: 'Banko pavadinimas',
    swift: 'Swift',
    currency: 'Valiuta',
    iban: 'IBAN',
    invoicing: 'Sąskaitų išrašymas',
    decimalPlaces: 'Dešimtainiai skaičiai',
    invoicesPrefix: 'Sąskaitų prefiksas',
    currentInvoiceNumber: 'Dabartinis sąskaitos numeris',
    creditNotesPrefix: 'Kreditinių pažymų prefiksas',
    currentCreditNoteNumber: 'Dabartinis kreditinės pažymos numeris',
    lastInvoiceDate: 'Paskutinės sąskaitos data',
    noInvoicesYet: 'Sąskaitos dar nesukurtos.',
    confirmReverting: 'Patvirtinti sistemos atstatymą',
    allInvoicesAfter: 'Visos sąskaitos ir jų storno išrašytos po',
    willBeRemoved: 'bus pašalintos. Tęsti sistemos atstatymą?',
    cancel: 'Atšaukti',
    revert: 'Atstatyti',
    revertDesc: 'Sistemos atstatymas ištrins visas sąskaitas sukurtas po pasirinktos datos.',
    revertToDate: 'Atstatyti iki šios datos',
    reverting: 'Atstatoma sistema, palaukite...',
    useOrderNumbering: 'Naudoti užsakymų numeraciją',
    showVat: 'Rodyti PVM sąskaitose',
    overrideTaxes: 'Perrašyti mokesčius',
    pricesIncludeTax: 'Kainos su mokesčiais',
    productsTaxRate: 'Produktų mokesčio tarifas',
    shippingTaxRate: 'Pristatymo mokesčio tarifas',
    skusSeparated: 'SKU atskirti kabliataškiu',
    skusTaxRate: 'SKU mokesčio tarifas',
    useOrderDates: 'Naudoti užsakymų kūrimo datas sąskaitoms',
    convertCurrency: 'Konvertuoti kainas į valiutą kuria klientas moka',
    unsavedChanges: 'Neišsaugoti pakeitimai',
    discard: 'Atmesti',
    save: 'Išsaugoti',
  },
  drafts: {
    pageTitle: 'Juodraščiai',
    pageDescription: 'Manage your draft orders',
    title: 'Juodraščiai',
    download: 'Atsisiųsti',
    newDraft: 'Naujas juodraštis',
    exporting: 'Eksportuojama {status}%...',
    accessNotGranted: 'Prieiga prie juodraščių užsakymų nesuteikta. Prašome',
    reLogin: 'prisijungti iš naujo',
    toGrantPermissions: 'norėdami suteikti reikiamus „Juodraščių užsakymų" leidimus.',
    pushFailed: 'Siuntimas į Shopify nepavyko:',
    exportError: 'Eksporto klaida:',
    confirmDelete: 'Ar tikrai norite ištrinti šį juodraštį?',
    incompleteCustomer: 'Kliento duomenys nepilni:',
    pushWithoutCustomer: 'Juodraštis bus nusiųstas į Shopify be kliento duomenų. Tęsti?',
    customerNotInShopify: 'Šis klientas dar neegzistuoja Shopify.',
    warnings: 'Įspėjimai:',
    createCustomerAndPush: 'Sukurti klientą Shopify ir nusiųsti juodraščio užsakymą?',
    downloadTitle: 'Atsisiųsti juodraščius',
    cancel: 'Atšaukti',
  },
  draftEdit: {
    number: "Numeris",
    prefix: "Priešdėlis",

    newDraft: 'Naujas juodraštis',
    editDraft: 'Redaguoti juodraštį',
    viewInShopify: 'Peržiūrėti Shopify',
    back: 'Atgal',
    createDraft: 'Sukurti juodraštį',
    saveChanges: 'Išsaugoti pakeitimus',
    documentType: 'Dokumento tipas',
    draftOrder: 'Juodraščio užsakymas',
    quote: 'Pasiūlymas',
    proforma: 'Išankstinė sąskaita',
    manualInvoice: 'Rankinė sąskaita',
    currency: 'Valiuta',
    expiryDate: 'Galiojimo data',
    status: 'Būsena',
    draft: 'Juodraštis',
    sent: 'Išsiųsta',
    accepted: 'Priimta',
    customer: 'Klientas',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    email: 'El. paštas',
    phone: 'Telefonas',
    company: 'Įmonė',
    taxId: 'Mokesčių mokėtojo kodas',
    billingAddress: 'Atsiskaitymo adresas',
    address: 'Adresas',
    aptSuite: 'Butas/Ofisas',
    city: 'Miestas',
    province: 'Rajonas',
    countryField: 'Šalis',
    zip: 'Pašto kodas',
    shippingAddress: 'Pristatymo adresas',
    sameAsBilling: 'Toks pat kaip atsiskaitymo',
    lineItems: 'Eilutės',
    shipping: 'Pristatymas',
    shippingTitle: 'Pavadinimas',
    shippingPlaceholder: 'pvz. Standartinis pristatymas',
    price: 'Kaina',
    note: 'Pastaba',
    notePlaceholder: 'Vidinė pastaba arba žinutė klientui...',
    summary: 'Suvestinė',
    subtotal: 'Tarpinė suma',
    discounts: 'Nuolaidos',
    tax: 'Mokestis',
    total: 'Iš viso',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Įveskite savo parduotuvės adresą',
    loginWith: 'Prisijungti su',
    createAccount: 'Sukurti naują paskyrą',
    placeholder: 'jūsų-parduotuvės-pavadinimas',
    shopRequired: 'Parduotuvės pavadinimas yra privalomas',
    login: 'Prisijungti',
    shopify: 'Shopify',
    terms: 'Naudojimo sąlygos',
    privacy: 'Privatumo politika',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Patinka Invoice Browse?',
    description: "Jūs sukūrėte savo pirmąsias sąskaitas! Jei programa jums naudinga, greitas atsiliepimas Shopify App Store mums labai padeda.",
    reward: "Kaip padėką, mes atnaujomsime jūsų mėnesinį naudojimo skaitiklį iki 0",
    leaveReview: 'Palikti atsiliepimą',
    maybeLater: 'Gal vėliau',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Sveiki atvykę į Invoice Browse',
    welcomeContent: 'Leiskite parodyti kaip galite naudoti programą.',
    dashboardTitle: 'Valdymo skydas',
    dashboardContent: 'Ekranas kurį matote yra pagrindinis valdymo skydas. Čia galite rasti visus užsakymus ir eksportuoti juos į skirtingus dokumentų tipus: sąskaitas, pakavimo lapelius ir kitus.',
    automationTitle: 'Palengvinkite savo gyvenimą',
    automationContent: 'Įjunkite automatizavimą norėdami kurti sąskaitas kai užsakymai apmokomi arba grąžinami.',
    templatesTitle: 'Pritaikyti šablonus',
    templatesContent: 'Įeikite čia norėdami išversti šabloną, jį pritaikyti arba sukurti naują.',
    deliveryTitle: 'Pristatymas',
    deliveryContent: 'Konfigūruokite programą automatiškai kopijuoti sukurtus dokumentus į FTP, Google Drive arba kaip el. laiškų priedus.',
    settingsTitle: 'Nustatymai',
    settingsContent1: 'Koreguokite įmonės telefono numerį, el. paštą ir kitus laukus naudojamus dokumentuose.',
    settingsContent2: 'Pakeiskite dokumento pradinį numerį arba ištrinkite dokumentus sukurtus po tam tikros datos.',
    settingsContent3: 'Perrašykite PVM tarifus pristatymui ir produktams',
    settingsContent4: 'Pakeiskite dešimtainių skaičių kiekį',
    reviewTitle: 'Parašyti atsiliepimą',
    reviewContent: 'Palaikykite mūsų komandą parašydami gerą atsiliepimą!',
    tourTitle: 'Pažintinė ekskursija',
    tourContent: 'Ei, galite vėl atidaryti šią ekskursiją iš čia.',
    createDocTitle: 'Sukurkite savo pirmą dokumentą',
    createDocContent: 'Spauskite mygtuką Sukurti norėdami sukurti savo pirmą dokumentą.',
    docNumberTitle: 'Dokumento numeris',
    docNumberContent: 'Pirmam dokumentui priskirtas numeris 1. Jei norite pradėti nuo kito numerio, galite tai pakeisti Nustatymuose.',
    downloadDocTitle: 'Atsisiųsti dokumentą',
    downloadDocContent: 'Spauskite ant Atsisiųsti išskleidžiamojo meniu ir pasirinkite dokumento šabloną norėdami eksportuoti užsakymą kaip PDF.',
  },
  common: {
    save: 'Išsaugoti',
    cancel: 'Atšaukti',
    close: 'Uždaryti',
    discard: 'Atmesti',
    delete: 'Ištrinti',
    edit: 'Redaguoti',
    create: 'Sukurti',
    loading: 'Kraunama...',
    unsavedChanges: 'Neišsaugoti pakeitimai',
    upgradePlan: 'Atnaujinti planą',
  },
  languageSelector: {
    label: 'Kalba',
    auto: 'Automatinis aptikimas',
  },
  draftList: {
    draftNum: 'Juodraštis #',
    shopifyId: 'Shopify ID',
    type: 'Tipas',
    customer: 'Klientas',
    total: 'Viso',
    status: 'Būsena',
    delivered: 'Pristatyta',
    date: 'Data',
    actions: 'Veiksmai',
    noCustomer: 'Nėra kliento',
    noDrafts: 'Nerasta juodraščių ar pasiūlymų.',
    loading: 'Kraunama...',
    download: 'Atsisiųsti',
    default: 'Numatytasis',
    pending: 'Laukiama',
    deliverNow: 'Pristatyti dabar',
    deliveryDetails: 'Pristatymo informacija',
    sent: 'Išsiųsta',
    failed: 'Nepavyko',
    deliverAgain: 'Pristatyti dar kartą',
    partial: 'Dalinė',
    notDelivered: 'Nepristatyta',
    deliveryFailed: 'Pristatymas nepavyko',
    unknown: 'Nežinoma',
    edit: 'Redaguoti',
    send: 'Siųsti',
    pushToShopify: 'Siųsti į Shopify',
    complete: 'Užbaigti',
    duplicate: 'Kopijuoti',
    delete: 'Ištrinti',
    quote: 'Pasiūlymas',
    proforma: 'Proforma',
    draftOrder: 'Juodraštinis užsakymas',
    manualInvoice: 'Rankinė sąskaita',
  },
  draftSearch: {
    createdBtw: 'Sukurta tarp',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Klientas',
    status: 'Būsena',
    type: 'Tipas',
    delivery: 'Pristatymas',
    any: 'Visi',
    draft: 'Juodraštis',
    sent: 'Išsiųsta',
    accepted: 'Priimta',
    expired: 'Pasibaigė',
    converted: 'Konvertuota',
    cancelled: 'Atšaukta',
    quote: 'Pasiūlymas',
    proforma: 'Proforma',
    draftOrder: 'Juodraštinis užsakymas',
    manualInvoice: 'Rankinė sąskaita',
    delivered: 'Pristatyta',
    notDelivered: 'Nepristatyta',
    pending: 'Laukiama',
    search: 'Ieškoti',
  },
  draftDownload: {
    title: 'Atsisiųsti Juodraštis #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Būsena',
    documentType: 'Tipas',
    any: 'Visi',
    draft: 'Juodraštis',
    sent: 'Išsiųsta',
    accepted: 'Priimta',
    expired: 'Pasibaigė',
    converted: 'Konvertuota',
    cancelled: 'Atšaukta',
    quote: 'Pasiūlymas',
    proforma: 'Proforma',
    draftOrder: 'Juodraštinis užsakymas',
    manualInvoice: 'Rankinė sąskaita',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Įdiegti naują šabloną',
    tabStyle: 'Stilius',
    tabContent: 'Turinys',
    tabTranslations: 'Vertimai',
    tabSettings: 'Nustatymai',
    tabCode: 'Kodas',
    tabCopilot: 'AI Kopilotas',
    logo: 'Logotipas',
    colorPalette: 'Spalvų paletė',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/lt.js